import { j as d } from "../../_virtual/jsx-runtime.js";
import { c as p } from "../../_virtual/compiler-runtime.js";
import { use as C, createContext as k } from "react";
import { Root as R, Fallback as V, Image as I } from "../../bundled_deps/.pnpm/@radix-ui_react-avatar@1.1.11_@types_react-dom@19.2.3_@types_react@19.2.14__@types_reac_5e99ccf265cbb36ef8e7150da8f5489e/bundled_deps/@radix-ui/react-avatar/dist/index.js";
import { tv as h } from "../../bundled_deps/.pnpm/tailwind-variants@0.3.1_tailwindcss@3.4.17/bundled_deps/tailwind-variants/dist/index.js";
import { cn as x } from "../../utils/cn.js";
import { AVATAR_COLORS as g } from "../../utils/constants.js";
function S(i, e) {
  if (!i)
    return e[0];
  let t = 0;
  for (let s = 0; s < i.length; s++)
    t = (t << 5) - t + i.charCodeAt(s), t &= t;
  t = Math.abs(t);
  const l = t % e.length;
  return e[l];
}
function F(i) {
  return S(i ?? "", g);
}
const $ = h({
  base: "relative inline-flex select-none items-center justify-center rounded-full shrink-0",
  variants: {
    size: {
      "x-small": "h-3 w-3",
      small: "h-4 w-4",
      medium: "h-6 w-6",
      large: "h-12 w-12"
    }
  },
  defaultVariants: {
    size: "small"
  }
}), O = h({
  base: "flex items-center justify-center select-none h-full w-full",
  variants: {
    size: {
      "x-small": "text-[8px] font-semibold",
      small: "text-[9px] font-semibold",
      medium: "text-base-bold",
      large: "text-h1"
    }
  },
  defaultVariants: {
    size: "small"
  }
}), T = h({
  base: "absolute rounded-full outline outline-base-module bottom-0 right-0",
  variants: {
    value: {
      active: "bg-success-fill",
      away: "bg-notice-fill"
    },
    size: {
      "x-small": "size-1 outline-1",
      small: "size-1 outline-1",
      medium: "size-1.5 outline-2",
      large: "size-3 outline-[3px]"
    }
  },
  defaultVariants: {
    value: "active",
    size: "small"
  }
}), A = k({
  size: "small"
});
A.displayName = "AvatarContext";
function z() {
  return C(A);
}
function N(i) {
  const e = p.c(15);
  let t, l, a;
  e[0] !== i ? ({
    size: a,
    className: t,
    ...l
  } = i, e[0] = i, e[1] = t, e[2] = l, e[3] = a) : (t = e[1], l = e[2], a = e[3]);
  const s = a === void 0 ? "small" : a;
  let n;
  e[4] !== s ? (n = {
    size: s
  }, e[4] = s, e[5] = n) : n = e[5];
  let o;
  e[6] !== t || e[7] !== s ? (o = x($({
    size: s
  }), t), e[6] = t, e[7] = s, e[8] = o) : o = e[8];
  let r;
  e[9] !== l || e[10] !== o ? (r = /* @__PURE__ */ d.jsx(R, { "data-testid": "avatar-root", className: o, ...l }), e[9] = l, e[10] = o, e[11] = r) : r = e[11];
  let c;
  return e[12] !== n || e[13] !== r ? (c = /* @__PURE__ */ d.jsx(A, { value: n, children: r }), e[12] = n, e[13] = r, e[14] = c) : c = e[14], c;
}
N.displayName = "Avatar";
function j(i) {
  const e = p.c(8);
  let t, l;
  e[0] !== i ? ({
    className: t,
    ...l
  } = i, e[0] = i, e[1] = t, e[2] = l) : (t = e[1], l = e[2]);
  let a;
  e[3] !== t ? (a = x("h-full w-full rounded-full object-cover overflow-hidden", t), e[3] = t, e[4] = a) : a = e[4];
  let s;
  return e[5] !== l || e[6] !== a ? (s = /* @__PURE__ */ d.jsx(I, { className: a, "data-testid": "avatar-image", draggable: !1, ...l }), e[5] = l, e[6] = a, e[7] = s) : s = e[7], s;
}
j.displayName = "Avatar.Image";
function y(i) {
  const e = p.c(22);
  let t, l, a, s;
  e[0] !== i ? ({
    initials: a,
    color: l,
    className: t,
    ...s
  } = i, e[0] = i, e[1] = t, e[2] = l, e[3] = a, e[4] = s) : (t = e[1], l = e[2], a = e[3], s = e[4]);
  const {
    size: n
  } = z();
  let o;
  e[5] !== l || e[6] !== a ? (o = l ?? (a ? F(a) : g[0]), e[5] = l, e[6] = a, e[7] = o) : o = e[7];
  const r = o;
  let c;
  e[8] !== a ? (c = a ? a.charAt(0).toUpperCase() : "", e[8] = a, e[9] = c) : c = e[9];
  const b = c;
  let u;
  e[10] !== r || e[11] !== t ? (u = x("flex h-full w-full overflow-hidden rounded-full", r, t), e[10] = r, e[11] = t, e[12] = u) : u = e[12];
  let f;
  e[13] !== n ? (f = O({
    size: n
  }), e[13] = n, e[14] = f) : f = e[14];
  let m;
  e[15] !== b || e[16] !== f ? (m = /* @__PURE__ */ d.jsx("span", { className: f, children: b }), e[15] = b, e[16] = f, e[17] = m) : m = e[17];
  let v;
  return e[18] !== s || e[19] !== u || e[20] !== m ? (v = /* @__PURE__ */ d.jsx(V, { className: u, "data-testid": "avatar-fallback", ...s, children: m }), e[18] = s, e[19] = u, e[20] = m, e[21] = v) : v = e[21], v;
}
y.displayName = "Avatar.Fallback";
function w(i) {
  const e = p.c(11);
  let t, l, a;
  e[0] !== i ? ({
    className: t,
    value: a,
    ...l
  } = i, e[0] = i, e[1] = t, e[2] = l, e[3] = a) : (t = e[1], l = e[2], a = e[3]);
  const s = a === void 0 ? "active" : a, {
    size: n
  } = z();
  let o;
  e[4] !== t || e[5] !== n || e[6] !== s ? (o = x(T({
    value: s,
    size: n
  }), t), e[4] = t, e[5] = n, e[6] = s, e[7] = o) : o = e[7];
  let r;
  return e[8] !== l || e[9] !== o ? (r = /* @__PURE__ */ d.jsx("div", { className: o, "data-testid": "avatar-status", ...l }), e[8] = l, e[9] = o, e[10] = r) : r = e[10], r;
}
w.displayName = "Avatar.Status";
const B = Object.assign(N, {
  Image: j,
  Fallback: y,
  Status: w
});
export {
  B as Avatar,
  $ as avatarRootVariants,
  T as avatarStatusVariants,
  O as avatarTextVariants,
  F as getAvatarColor
};
